import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import * as navActions from './navigation.actions';
import { NavigationService } from '../navigation.service';

@Injectable()
export class NavigationEffects {

  loadNavigationItems$ = createEffect(() =>
    this.actions$.pipe(
      ofType(navActions.getNavItems),
      mergeMap(() =>
        this.navigationService.getNavigationItems().pipe(
          mergeMap((navItems) => [navActions.getNavItemsSuccess({ navItems })]),
          catchError((error) => of(navActions.getNavItemsFailure({ error })))
        )
      )
    )
  );

  addNavigationFavorite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(navActions.addFavorite),
      mergeMap((action) =>
        this.navigationService.addNavigationFavorite(action.favorite).pipe(
          mergeMap(() => []),
          catchError((error) => of(navActions.addFavoriteFailure({ favorite: action.favorite, error })))
        )
      )
    )
  );

  deleteNavigationFavorite$ = createEffect(() =>
    this.actions$.pipe(
      ofType(navActions.deleteFavorite),
      mergeMap((action) =>
        this.navigationService.deleteNavigationFavorite(action.favorite).pipe(
          mergeMap(() => []),
          catchError((error) => of(navActions.deleteFavoriteFailure({ favorite: action.favorite, error })))
        )
      )
    )
  );

  updateNavigationFavorites$ = createEffect(() =>
    this.actions$.pipe(
      ofType(navActions.updateFavorites),
      mergeMap((action) =>
        this.navigationService.updateNavigationFavorites(action.newFavorites).pipe(
          mergeMap(() => []),
          catchError((error) => of(navActions.updateFavoritesFailure({ oldFavorites: action.oldFavorites, error })))
        )
      )
    )
  );

  getNavFavorites$ = createEffect(() =>
    this.actions$.pipe(
      ofType(navActions.getNavFavorites),
      mergeMap(() =>
        this.navigationService.fetchNavigationFavorites().pipe(
          mergeMap((favorites) => [navActions.getNavFavoritesSuccess({ favorites })]),
          catchError((error) => of(navActions.getNavFavoritesFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private navigationService: NavigationService,
  ) { }
}
